// W31 (2026-10-20): shared "write is paused" button for the W2A-lower
// screens. Every Save / Send / Kixie / ticket button stays VISIBLE on a
// real session but is inert and labelled with the live-write gate so a
// rep never wonders whether a click did something. In preview mode the
// button renders its normal children and behaves as the design shows.
import type { MouseEventHandler, ReactNode } from 'react';

export const LIVE_WRITE_PAUSED_LABEL = 'Paused by the live-write gate';

export interface WriteButtonProps {
  /** True on a real session: the button is disabled and relabelled. */
  paused: boolean;
  /** Normal content (text + icon) when writes are allowed. */
  children: ReactNode;
  id?: string;
  className?: string;
  type?: 'button' | 'submit';
  /** Additional disabled reason that applies even in preview. */
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  /** Human name of the paused action for the tooltip, e.g. "Save changes". */
  actionLabel?: string;
}

export function WriteButton({
  paused,
  children,
  id,
  className,
  type = 'button',
  disabled = false,
  onClick,
  actionLabel,
}: WriteButtonProps): ReactNode {
  if (!paused) {
    return (
      <button id={id} className={className} type={type} disabled={disabled} onClick={onClick}>
        {children}
      </button>
    );
  }
  return (
    <button
      id={id}
      className={className}
      type="button"
      disabled
      aria-disabled="true"
      data-live-write-paused="true"
      title={actionLabel ? `${actionLabel}: ${LIVE_WRITE_PAUSED_LABEL}` : LIVE_WRITE_PAUSED_LABEL}
    >
      {LIVE_WRITE_PAUSED_LABEL}
    </button>
  );
}
